export class LeadFullResponseModel {
    amount: number;
    currencyCode: string;
    leadId: string;
    discountMeasure: string;
    discountAmount: number;
    productId: string;
    purposeId: string;
    bidRate: number;
    countryCode: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/leadFull/LeadFullResponseModel.ts